/// <reference types="vite/client" />
/**
 * 用户端的内置词条种子（TECH-BRIEF §5：运行时以 A45 词条库为准，构建时内置种子作为兜底）。
 *
 * 只收录用户端命名空间（不含 `admin`、`*-admin`，也不含只由服务端渲染的 `notify`），并去掉员工邮件模板（surface.ts）。
 * apps/web 只经由本模块取种子：本模块不引用任何后台命名空间与服务端渲染命名空间的文件，员工邮件模板（`notify-admin`）、
 * 通知模板与其他后台词条都不会进入用户端的构建产物（D-P0-06-03 更新；INTEGRATE D-INT-14）。bundled.test.ts 按文件内容核对。
 * 后台用 bundled-admin.ts。
 */
import { createSeedLoader, indexSeeds, type SeedImporters } from './seed-loader.js';
import type { Messages, NamespacedLoader } from './runtime.js';
import { isUserSurfaceEntry } from './surface.js';

// Vite 把下面的调用静态展开为按文件的动态 import（排除模式与 surface.ts 的 isAdminNamespace、SERVER_RENDERED_NAMESPACES 一致，须为字面量）
export const USER_SEED_FILES: SeedImporters = import.meta.glob<Messages>(
  ['../locales/*/*.json', '!../locales/*/admin.json', '!../locales/*/*-admin.json', '!../locales/*/notify.json'],
  { import: 'default' },
);

const userIndex = indexSeeds(USER_SEED_FILES);

/** 用户端命名空间（不含后台命名空间与服务端渲染命名空间）。 */
export const USER_NAMESPACES: readonly string[] = userIndex.namespaces;

/** 用户端内置种子：只含用户端命名空间，并去掉员工邮件模板。apps/web 使用。 */
export const userSeedLoader: NamespacedLoader = createSeedLoader(userIndex, isUserSurfaceEntry);
